import { INav } from './INav';

export interface LeftNav {
  left?: INav[];
  top?: INav[];
}
